import WidgetBase from '../widget.base';

export default class EventPromotionDetailWidget extends WidgetBase {
    static selector = '[data-js-event-promotion-detail]';

    constructor(el) {
        super(el);
        const addToCalendarButton = this.el.querySelector('.ww-epd__add-cal');
        const addToCalendarList = this.el.querySelector('.ww-epd__add-cal-items');
        this.setupAddToCalendar(addToCalendarButton, addToCalendarList);

        setTimeout(() => {
            this.loaded();
        })
    }

    setupAddToCalendar = (button, list) => {
        if (!button || !list) {
            return;
        }

        button.addEventListener('click', () => {
            list.classList.toggle('open');
        });
    }
}